module.exports = __webpack_public_path__ + "static/media/utk.2e727645.svg";